/**
 * PH Cart Drawer – Timer, Upsell-Karussell & AJAX-Hilfsfunktionen
 */
(function () {
  const STORAGE_KEY = 'ph-cart-reservation-end';
  const UPSELL_AUTO_PLAY_MS = 10000;
  let timerInterval = null;

  function clearUpsellAutoPlay(carousel) {
    if (carousel?._phAutoPlayTimer) {
      clearInterval(carousel._phAutoPlayTimer);
      carousel._phAutoPlayTimer = null;
    }
  }

  function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  function getTimerElements(drawer) {
    return drawer ? drawer.querySelectorAll('[data-reservation-timer]') : [];
  }

  function getDaysAfterToday() {
    const check = new Date();
    check.setDate(check.getDate() + 2);
    if (check.getDay() === 0) return 3;
    return 2;
  }

  function formatShortDeliveryDate(date) {
    const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    return `${weekdays[date.getDay()]}. ${date.getDate()}.${date.getMonth() + 1}.`;
  }

  function initDeliveryEstimate(drawer) {
    if (!drawer) return;

    const rangeEl = drawer.querySelector('[data-delivery-range]');
    if (!rangeEl) return;

    const daysAfterToday = getDaysAfterToday();
    const deliveryFrom = new Date();
    deliveryFrom.setDate(deliveryFrom.getDate() + daysAfterToday);

    const deliveryTo = new Date(deliveryFrom);
    deliveryTo.setDate(deliveryTo.getDate() + 1);

    rangeEl.textContent = `${formatShortDeliveryDate(deliveryFrom)} - ${formatShortDeliveryDate(deliveryTo)}`;
  }

  function renderTimerDisplay(drawer, secondsLeft) {
    const template = drawer.dataset.timerTemplate || 'Dein Filter ist nur noch {timer} für dich reserviert. ⚡';
    const display = `<strong data-timer-display>${formatTime(secondsLeft)}</strong>`;
    const html = template.replace('{timer}', display);

    getTimerElements(drawer).forEach((el) => {
      el.innerHTML = html;
    });
  }

  function initReservationTimer(drawer) {
    if (!drawer) return;

    clearInterval(timerInterval);

    const minutes = parseInt(drawer.dataset.timerMinutes, 10) || 5;
    const durationMs = minutes * 60 * 1000;
    let endTime = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);

    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + durationMs;
      sessionStorage.setItem(STORAGE_KEY, String(endTime));
    }

    function tick() {
      const secondsLeft = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      renderTimerDisplay(drawer, secondsLeft);

      if (secondsLeft <= 0) {
        clearInterval(timerInterval);
      }
    }

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function initUpsellCarousel(drawer) {
    if (!drawer) return;

    const carousel = drawer.querySelector('[data-upsell-carousel]');
    if (!carousel || carousel.dataset.initialized === 'true') return;

    const track = carousel.querySelector('[data-upsell-track]');
    const viewport = carousel.querySelector('[data-upsell-viewport]');
    const slides = carousel.querySelectorAll('[data-upsell-slide]');
    const prevBtn = carousel.querySelector('[data-upsell-prev]');
    const nextBtn = carousel.querySelector('[data-upsell-next]');
    const copyEl = carousel.querySelector('[data-rec-copy]');
    const headingEl = carousel.querySelector('[data-rec-heading]');
    const subtextEl = carousel.querySelector('[data-rec-subtext]');

    if (!track || slides.length === 0) return;

    clearUpsellAutoPlay(carousel);
    carousel.dataset.initialized = 'true';
    carousel.classList.toggle('ph-cart-drawer__recommendations--single', slides.length <= 1);
    let currentIndex = 0;
    let copyFadeTimer = null;

    if (slides.length <= 1) {
      if (prevBtn) {
        prevBtn.hidden = true;
        prevBtn.setAttribute('hidden', '');
      }
      if (nextBtn) {
        nextBtn.hidden = true;
        nextBtn.setAttribute('hidden', '');
      }
    } else {
      if (prevBtn) {
        prevBtn.hidden = false;
        prevBtn.removeAttribute('hidden');
        prevBtn.disabled = false;
      }
      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.removeAttribute('hidden');
        nextBtn.disabled = false;
      }
    }

    function updateSlideCopy(index) {
      const slide = slides[index];
      if (!slide || !headingEl || !subtextEl) return;

      const newHeading = slide.dataset.slideHeading || '';
      const newSubtext = slide.dataset.slideSubtext || '';

      if (headingEl.textContent === newHeading && subtextEl.textContent === newSubtext) return;

      clearTimeout(copyFadeTimer);

      if (copyEl) copyEl.classList.add('is-fading');

      copyFadeTimer = setTimeout(() => {
        headingEl.textContent = newHeading;
        subtextEl.textContent = newSubtext;
        if (copyEl) copyEl.classList.remove('is-fading');
      }, 150);
    }

    function goToSlide(index) {
      currentIndex = ((index % slides.length) + slides.length) % slides.length;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      updateSlideCopy(currentIndex);
    }

    function goToNext() {
      goToSlide(currentIndex + 1);
      restartAutoPlay();
    }

    function goToPrev() {
      goToSlide(currentIndex - 1);
      restartAutoPlay();
    }

    function startAutoPlay() {
      clearUpsellAutoPlay(carousel);
      if (slides.length <= 1) return;

      carousel._phAutoPlayTimer = setInterval(goToNext, UPSELL_AUTO_PLAY_MS);
    }

    function restartAutoPlay() {
      if (slides.length <= 1) return;
      startAutoPlay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', goToPrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', goToNext);
    }

    if (viewport && slides.length > 1) {
      let touchStartX = 0;

      viewport.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          const diff = touchStartX - event.changedTouches[0].screenX;
          if (Math.abs(diff) < 50) return;
          if (diff > 0) goToNext();
          else goToPrev();
        },
        { passive: true }
      );
    }

    goToSlide(0);
    startAutoPlay();
  }

  function resetUpsellCarousel(drawer) {
    const carousel = drawer?.querySelector('[data-upsell-carousel]');
    if (carousel) {
      clearUpsellAutoPlay(carousel);
      delete carousel.dataset.initialized;
      const track = carousel.querySelector('[data-upsell-track]');
      if (track) track.style.transform = '';
    }
  }

  function initUpsellButtons(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('[data-upsell-add]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.classList.contains('loading')) return;

        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        btn.classList.add('loading');
        btn.disabled = true;

        try {
          const sections = cartDrawer.getSectionsToRender().map((s) => s.id);
          const body = JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          });

          const response = await fetch(`${window.routes.cart_add_url}`, {
            ...fetchConfig(),
            body,
          });

          const data = await response.json();

          if (data.status) {
            console.error('Upsell add error:', data.message);
            btn.disabled = false;
          } else {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ph-cart-drawer',
              cartData: data,
            });
            resetUpsellCarousel(cartDrawer);
            cartDrawer.renderContents(data);
          }
        } catch (err) {
          console.error(err);
          btn.disabled = false;
        } finally {
          btn.classList.remove('loading');
        }
      });
    });
  }

  function initPhCartDrawerFeatures(drawer) {
    if (!drawer) return;
    initDeliveryEstimate(drawer);
    resetUpsellCarousel(drawer);
    initUpsellCarousel(drawer);
    initUpsellButtons(drawer);
  }

  function patchPhCartDrawer() {
    const CartDrawerProto = customElements.get('cart-drawer')?.prototype;
    if (!CartDrawerProto || CartDrawerProto._phPatched) return;

    const originalOpen = CartDrawerProto.open;
    CartDrawerProto.open = function (...args) {
      originalOpen.apply(this, args);
      initPhCartDrawerFeatures(this);
    };

    const originalRenderContents = CartDrawerProto.renderContents;
    CartDrawerProto.renderContents = function (...args) {
      originalRenderContents.apply(this, args);
      setTimeout(() => initPhCartDrawerFeatures(this), 50);
    };

    CartDrawerProto._phPatched = true;
  }

  function patchPhCartDrawerItems() {
    const CartDrawerItemsProto = customElements.get('cart-drawer-items')?.prototype;
    if (!CartDrawerItemsProto || CartDrawerItemsProto._phPatched) return;

    const originalOnCartUpdate = CartDrawerItemsProto.onCartUpdate;
    CartDrawerItemsProto.onCartUpdate = function () {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.ph-cart-drawer__recommendations', '.ph-cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            const countEl = drawer.querySelector('[data-cart-item-count]');
            const newCount = html.querySelector('[data-cart-item-count]');
            if (countEl && newCount) countEl.textContent = newCount.textContent;

            resetUpsellCarousel(drawer);
            initPhCartDrawerFeatures(drawer);
          }
        })
        .catch((e) => console.error(e));
    };

    CartDrawerItemsProto._phPatched = true;
  }

  function init() {
    patchPhCartDrawer();
    patchPhCartDrawerItems();

    const drawer = document.querySelector('cart-drawer');
    if (drawer) initPhCartDrawerFeatures(drawer);

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          resetUpsellCarousel(cartDrawer);
          initPhCartDrawerFeatures(cartDrawer);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
